module.exports = __webpack_public_path__ + "img/cases-brand-avic-lazyload-51.8d03a6e5.jpg";